import React from 'react';
import styles from './css/index.module.scss';
import convertPhoneNumber from '../../helpers/convertPhoneNumber';
import { BUY_VIDEO_URL, SELL_VIDEO_URL } from '../../constants/tutorials';
import useTranslations from '../../hooks/useTranslations';
import { DICTIONARY } from '../../translations/dictionary';
import EmptyHeight from '../../components/EmptyHeight';

function Tutorials() {
  const { t } = useTranslations();
  return (
    <div className={styles.wrapper}>
      <p className={styles.header}>
        {t(DICTIONARY.tutorials)}
      </p>
      <EmptyHeight height={30} />

      <p className={styles.videoTitle}>{t(DICTIONARY.howToSell)}</p>
      <video className={styles.video} controls>
        <source src={SELL_VIDEO_URL} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <EmptyHeight height={60} />
      <p className={styles.videoTitle}>{t(DICTIONARY.howToBuy)}</p>
      <video className={styles.video} controls>
        <source src={BUY_VIDEO_URL} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export default Tutorials;
